const daysItineraryDescription = {
  id: '',
  mainTitle: '',
  description: '',
  position: 1,
  active: true
};

export default daysItineraryDescription;
